export default __webpack_public_path__ + "static/fiema-logo-bcb7dd4885b3b7a3e969190ab53464de.png";